import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as FacilitiesActions from '../../actions/facilities_actions';
import { bindActionCreators } from 'redux';
import { FacilitiesHeader } from './facility-header';
import { FacilitiList } from './facility-list';
import { Addfacility } from './add-facility';
import { ModalDialog } from '../modal_dialog';
import _ from 'lodash';
import Header from '../../components/header';
import Pagination from "react-js-pagination";

let screenIdentifier = 'facilities';

let Facilities = React.createClass({
    getInitialState() {
        return {
            listView: false,
            gridview: true,
            facilitiList: 0,
            toggleView: 0,
            propsRecived: 0,
            //toggleClassName: 'grid-view',
            dialog: false,
            add_admin: false,
            add_admin_later: false,
            facilitListItem: null,

            //pagination
            pageNO: 1, // To make currentPage active in UI
            PageSize: 9,
            totalRecords: 9,
            searchWord: '',
        }
    },
    componentWillMount() {
        //this.props.Dispatch(FacilitiesActions.getAllfacilities());
        this.props.Dispatch(FacilitiesActions.getfacilitiesbySearch({
            "searchChar": '',
            "page": 1,
            "size": 9,
        }));

        this.props.FacilitiesDetails.FaciliteDetailsByID = {};

        // To Set Facilities in local state variables
        if (this.props.FacilitiesDetails.FaciliteDetails && this.props.FacilitiesDetails.FaciliteDetails.data) {
            if (this.props.FacilitiesDetails.FaciliteDetails.data.result && this.props.FacilitiesDetails.FaciliteDetails.data.result.length) {
                this.setState({ facilitListItem: this.props.FacilitiesDetails.FaciliteDetails.data.result });
                this.setState({ totalRecords: this.props.FacilitiesDetails.FaciliteDetails.data.totalSize });
            }
            else {
                //  this.props.router.push('/add-facility#new');
            }
        }


        // if (!AllfacilitDetails) { this.props.router.push('/add-facility#new') }
        // document.body.scrollTop = document.documentElement.scrollTop = 0;

        // To handle listView or GridView
        // if (this.props.FacilitiesDetails && this.props.FacilitiesDetails.FacilitiesListViewType) {
        //     this.setState({ toggleClassName: this.props.FacilitiesDetails.FacilitiesListViewType });
        // }
    },
    componentWillReceiveProps(nextProps) {
        // To Set Facilities in local state variables
        if (nextProps.FacilitiesDetails.FaciliteDetails && nextProps.FacilitiesDetails.FaciliteDetails.data) {
            nextProps.FacilitiesDetails.FaciliteDetails.status = null;
            this.setState({ facilitListItem: nextProps.FacilitiesDetails.FaciliteDetails.data.result });
            this.setState({ totalRecords: nextProps.FacilitiesDetails.FaciliteDetails.data.totalSize });
        }

        if (nextProps.FacilitiesDetails.FaciliteDetailsByID ? nextProps.FacilitiesDetails.FaciliteDetailsByID.status == 200 : false) { this.props.router.push('/facilities/details'); }
    },
    componentDidMount() {

    },

    addNewFacility() {
        this.props.router.push('/add-facility');
        document.body.scrollTop = document.documentElement.scrollTop = 0; // to scroll to top in samll screen
    },

    //On Search word change -- To get searched facilities with entered character
    onSearchChange(event) {
        // if (event.target.value.trim().length === 0) {
        //     return;
        // }
        this.setState({ searchWord: event.target.value.trim() });
        this.setState({ pageNO: 1 }); // To make the pageNo active in UI component.

        this.props.Dispatch(FacilitiesActions.getfacilitiesbySearch({
            "searchChar": event.target.value.trim(),
            "page": 1,
            "size": this.state.PageSize,
        }));
    },

    add_dmin(event) {
        var faciliti_id = event.target.getAttribute("data-facilit-id");
        this.props.router.push('/facilities/admin/add?id=' + faciliti_id);
        document.body.scrollTop = document.documentElement.scrollTop = 0; // to scroll to top in samll screen
    },
    toggleView() {
        var toggleState = this.state.toggleView == 0 ? 1 : 0;

        this.setState({ toggleView: toggleState });

    },
    toggletoList() {
        //this.setState({ toggleClassName: 'list-view' });
        this.props.Dispatch(FacilitiesActions.setFacilitiesListViewType('list-view'));
    },
    toggletoGrid() {
        //this.setState({ toggleClassName: 'grid-view' });
        this.props.Dispatch(FacilitiesActions.setFacilitiesListViewType('grid-view'));
    },
    view_faciliti(e) {

        var faciliti_id = e.currentTarget.getAttribute("data-facilit-id");
        this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(faciliti_id));
        //this.props.router.push('/facilities/details');

    },

    //on Page Change -- To get searched facilities with entered character
    onPageChange(pageNumber) {
        this.setState({ pageNO: pageNumber });
        this.props.Dispatch(FacilitiesActions.getfacilitiesbySearch({
            "searchChar": this.state.searchWord,
            "page": pageNumber,
            "size": this.state.PageSize,
        }));
    },

    render() {

        var template = <FacilitiList search={this.onSearchChange} add_dmin={this.add_dmin} viewAction={this.view_faciliti} data={this.state.facilitListItem} toggleClass={this.props.FacilitiesDetails.FacilitiesListViewType} toggletoList={this.toggletoList} toggletoGrid={this.toggletoGrid} addNew={this.addNewFacility} list={this.state.facilitiList} />;
        //  var templateAddNew =<Addfacility add={this.addFacility}/>;
        return (
            <div className="dashboard-inner-content">
                <Header screenIdentifier={screenIdentifier} />
                {template}
                <div> {this.state.dialog ? <ModalDialog addadmin={this.add_admin} doitlater={this.add_admin_later} /> : ""}
                </div>

                {(this.state.facilitListItem && this.state.facilitListItem.length > 0 && this.state.totalRecords >= this.state.PageSize) &&
                    <Pagination
                        activePage={this.state.pageNO}
                        itemsCountPerPage={this.state.PageSize}
                        totalItemsCount={this.state.totalRecords}
                        pageRangeDisplayed={5}
                        onChange={this.onPageChange} />
                }
            </div>

        );
    }
});

let mapStateToProps = (state) => {
    return {
        FacilitiesDetails: state.Facilites,
    };
};

let mapDispatchToProps = (dispatch) => ({
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(Facilities));



/** WEBPACK FOOTER **
 ** ./src/components/facilitiesScreen/facilities.js
 **/